import { CircularProgress, Typography } from '@material-ui/core';
import React from 'react';

import { useImgSrc } from 'core/utils/use-img-src.hook';
import { StyledUploadedImg } from './styles';

/**
 * Fetches and displays an uploaded image answer (requires auth token via useImgSrc).
 */
export function UploadedImage({ imageIri }: { imageIri: string }): JSX.Element {
  const { src, loading, error } = useImgSrc(imageIri);
  if (loading) return <CircularProgress size={24} />;
  if (error || !src)
    return (
      <Typography variant="body2" color="error">
        –
      </Typography>
    );
  return <StyledUploadedImg src={src} alt="" />;
}
